import KioskTimeoutKicker from './KioskTimeoutKicker.jsx';

export default KioskTimeoutKicker;


// WEBPACK FOOTER //
// ./src/components/KioskTimeoutKicker/index.jsx